// 获取动态用户列表
export const GET_DYNAMIC_USER_MENU = 'GET_DYNAMIC_USER_MENU'

// 获取静态用户列表
export const GET_STATIC_USER_MENU = 'GET_STATIC_USER_MENU'

// 获取团队日结报表
export const GET_TEAM_HISTORY = 'GET_TEAM_HISTORY';

// 获取个人日工资
export const GET_PERSONAL_DAILY_WAGE = 'GET_PERSONAL_DAILY_WAGE'

// 获取个人账变
export const GET_PERSONAL_SELFBANK_RECORD = 'GET_PERSONAL_SELFBANK_RECORD'

// 销毁报表当前视图数据
export const DISTROY_CURRENT_VIEW = 'DISTROY_CURRENT_VIEW' 

// 获取团队首页数据
export const GET_TEAM_USER_LIST = 'GET_TEAM_USER_LIST'

// 获取推广链接
export const GET_AGENT_REG_URL = 'GET_AGENT_REG_URL'

// 生成推广链接
export const MAKE_AGENT_REG_URL = 'MAKE_AGENT_REG_URL'

// 代理注册下级用户，检查用户名可用
export const  CHECK_USERNAME_FOR_REGISTER = 'CHECK_USERNAME_FOR_REGISTER'

// 获取下级返点信息
export const GET_FOLLOWER_REBET = 'GET_FOLLOWER_REBET'

// 设置下级返点
export const SET_FOLLOWER_REBET = 'SET_FOLLOWER_REBET'

// 获取下级日工资
export const GET_TEAM_SALARY = 'GET_TEAM_SALARY'

// 获取真人下级反水
export const GET_LIVE_TEAM_SALARY = 'GET_LIVE_TEAM_SALARY'

// 获取下级充值限额
export const GET_TRANSFER_LIMIT = 'GET_TRANSFER_LIMIT'

// 提交下级充值
export const SUBMIT_TEAM_GROUP_TRANSFER = 'SUBMIT_TEAM_GROUP_TRANSFER'

// 获取真人下级契约
export const GET_TEAM_COMPACT_LIVE = 'GET_TEAM_COMPACT_LIVE'

// 获取彩票投注记录
export const GET_LOTTERY_BET_HIS = 'GET_LOTTERY_BET_HIS'

// 获取真人下级契约详情 
export const GET_TEAM_COMPACT_DETAIL = 'GET_TEAM_COMPACT_DETAIL'

// 获取投注详情
export const GET_BET_DETAIL = 'GET_BET_DETAIL'

// 获取彩票报表概要信息【含盈亏】
export const GET_WINLOSS_SUMMERY = 'GET_WINLOSS_SUMMERY'

// 创建下级契约
export const CREATE_COMPACT = 'CREATE_COMPACT'

// 获取追号列表
export const GET_TRACE_HIS = 'GET_TRACE_HIS'

// 获取追号详情
export const GET_TRACE_HIS_DETAIL = 'GET_TRACE_HIS_DETAIL'

// 获取彩种信息
export const GET_LOTTERY_REBET_INFO = 'GET_LOTTERY_REBET_INFO'

// 修改下级契约
export const REVISE_COMPACT = 'REVISE_COMPACT'

// 停止追号
export const STOP_TRACE_BET = 'STOP_TRACE_BET'

// 获取日工资下级契约
export const GET_TEAM_COMPACT_DAILY = 'GET_TEAM_COMPACT_DAILY'

// 获取第三方游戏报表
export const GET_THRID_PARTY_GAME_REPORT_BYID = 'GET_THRID_PARTY_GAME_REPORT_BYID'
export const GET_THRID_PARTY_GAME_REPORT_BYNAME = 'GET_THRID_PARTY_GAME_REPORT_BYNAME'

// 获取第三方游戏投注记录
export const GET_THRID_PARTY_BET_REPORT = 'GET_THRID_PARTY_BET_REPORT'

// 获取常见问题
export const GET_Q_A = 'GET_Q_A';

// 获取玩法介绍
export const GET_METHOD_Q_A = 'GET_METHOD_Q_A'

// 获取体育下级契约
export const GET_TEAM_COMPACT_SPORT = 'GET_TEAM_COMPACT_SPORT'

// 获取真人反水
export const GET_LIVE_REBET = 'GET_LIVE_REBET'

// 获取体育反水
export const GET_SPORT_REBET = 'GET_SPORT_REBET'

// 完善个人资料
export const MODIFY_PROFILE = 'MODIFY_PROFILE'

// 获取第三方转账记录
export const GET_TRANSFER_RECORD = 'GET_TRANSFER_RECORD'

// 获取下级列表
export const GET_TEAM_GROUP_LIST = 'GET_TEAM_GROUP_LIST'

// 取消订单
export const CANCEL_GAME_ORDER = 'CANCEL_GAME_ORDER'

// 彩票账变
export const LOTTERY_ACCOUNT_CHANGED = 'LOTTERY_ACCOUNT_CHANGED'

// 彩票契约分红
export const LOTTERY_DIVIDENDS_PINK = 'LOTTERY_DIVIDENDS_PINK'

// 彩票契约查询分红发放状态
export const GET_LOTTERY_PINK_STATUS = 'GET_LOTTERY_PINK_STATUS'

// 发放分红
export const SEND_LOTTERY_PINK = 'SEND_LOTTERY_PINK'

// 查看分红契约
export const VIEW_LOTTERY_PINK = 'VIEW_LOTTERY_PINK'

// 销毁当前详情
export const DISTROY_CURRENT_DETAIL = 'DISTROY_CURRENT_DETAIL'

// 更新彩票契约分红
export const UPDATE_PINK_CONTRACT = 'UPDATE_PINK_CONTRACT'
// 创建彩票契约分红
export const CREATE_PINK_CONTRACT = 'CREATE_PINK_CONTRACT'
// 更新彩票契约分红
export const MODIFY_PINK_CONTRACT = 'MODIFY_PINK_CONTRACT'

